import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import Train from '../../services/train.js';

class GoogleSignIn extends Component {

  componentDidMount() {

    Train.fetchGoogleUrl()
    .then((location) => {
      window.location = location;
    });
  }


  render() {
    return (<div></div>);
  }

}

export default withRouter(GoogleSignIn);



// WEBPACK FOOTER //
// ./src/js/components/credentials/GoogleSignIn.jsx